// extracted by mini-css-extract-plugin
export var activeLink = "footer-module--activeLink--c9bf8";
export var black = "footer-module--black--55422";
export var booktocall = "footer-module--booktocall--bfa9e";
export var copyright = "footer-module--copyright--37395";
export var documents = "footer-module--documents--ab406";
export var footerDivider = "footer-module--footerDivider--2dd6e";
export var footerStyle = "footer-module--footerStyle--a5877";
export var footernav = "footer-module--footernav--9a649";
export var linkIcon = "footer-module--linkIcon--fdaa9";
export var logos = "footer-module--logos--9f413";
export var navLink = "footer-module--navLink--546e4";
export var navStyle = "footer-module--navStyle--c91d0";
export var navigationContainer = "footer-module--navigationContainer--89b02";
export var socialIcons = "footer-module--socialIcons--fabc9";
export var subfooter = "footer-module--subfooter--12c42";
export var subfooterContainer = "footer-module--subfooterContainer--1ab63";
export var white = "footer-module--white--8a462";